export function isExternalUrl(url: string) {
  return !/.*housinganywhere\.com/.test(url);
}
